export enum IntegrationsPlatform {
	WIX = 'wix',
	SHOPIFY = 'shopify',
	SHOPWARE = 'shopware',
	WOOCOMMERCE = 'woocommerce',
	HMRC = 'HMRC',
	SWISS_POST = 'swissPost',
	SQUARESPACE = 'squarespace',
	PRESTASHOP = 'prestashop',
	STRIPE = 'stripe',
}

export const INTEGRATIONS_PLATFORMS = [
	IntegrationsPlatform.SHOPIFY,
	IntegrationsPlatform.SHOPWARE,
	IntegrationsPlatform.WIX,
	IntegrationsPlatform.WOOCOMMERCE,
	IntegrationsPlatform.SQUARESPACE,
	IntegrationsPlatform.STRIPE,
	IntegrationsPlatform.HMRC,
	// IntegrationsPlatform.PRESTASHOP,
	// IntegrationsPlatform.SWISS_POST,
];

export const INTEGRATIONS_PLATFORMS_NAMES = {
	[IntegrationsPlatform.WIX]: 'Wix',
	[IntegrationsPlatform.SHOPIFY]: 'Shopify',
	[IntegrationsPlatform.SHOPWARE]: 'Shopware',
	[IntegrationsPlatform.WOOCOMMERCE]: 'WooCommerce',
	[IntegrationsPlatform.HMRC]: 'HMRC',
	[IntegrationsPlatform.SWISS_POST]: 'SwissPost',
	[IntegrationsPlatform.SQUARESPACE]: 'Squarespace',
	[IntegrationsPlatform.PRESTASHOP]: 'Prestashop',
	[IntegrationsPlatform.STRIPE]: 'Stripe',
};

export const INTEGRATIONS_PLATFORMS_IMG = {
	[IntegrationsPlatform.WIX]: '/img/platformLogo/wix.png',
	[IntegrationsPlatform.SHOPIFY]: '/img/platformLogo/shopify.png',
	[IntegrationsPlatform.SHOPWARE]: '/img/platformLogo/shopware.png',
	[IntegrationsPlatform.WOOCOMMERCE]: '/img/platformLogo/wooCommerce.png',
	[IntegrationsPlatform.HMRC]: '/img/platformLogo/hmrc.png',
	[IntegrationsPlatform.SWISS_POST]: '/img/platformLogo/swiss_post.svg',
	[IntegrationsPlatform.SQUARESPACE]: '/img/platformLogo/squarespace.svg',
	[IntegrationsPlatform.PRESTASHOP]: '/img/platformLogo/prestashop.svg',
	[IntegrationsPlatform.STRIPE]: '/img/platformLogo/stripe.svg',
};

export const INTEGRATIONS_PLATFORMS_IMG_TEXT = {
	[IntegrationsPlatform.WIX]: '',
	[IntegrationsPlatform.SHOPIFY]: '',
	[IntegrationsPlatform.SHOPWARE]: '',
	[IntegrationsPlatform.WOOCOMMERCE]: '',
	[IntegrationsPlatform.HMRC]: 'HM Revenue & Customs',
	[IntegrationsPlatform.SWISS_POST]: 'Swiss Post',
	[IntegrationsPlatform.SQUARESPACE]: '',
	[IntegrationsPlatform.PRESTASHOP]: '',
	[IntegrationsPlatform.STRIPE]: '',
};
